import axios from "axios";
import { awsLambdaURLPrefix } from "./utility";

// Calls one of our AWS Lambda endpoints (e.g. "send-mail",
// "presigned-upload-url") with a JSON body and returns the parsed response
// data, or false on error.
export const callLambda = async (urlSuffix: string, data: any) => {
  try {
    const result = await axios({
      method: "POST",
      url: awsLambdaURLPrefix + urlSuffix,
      data,
    });
    return result.data;
  } catch (err) {
    return false;
  }
};

// Uploads a single file to a presigned S3 URL via PUT. Returns true on success.
export const s3Upload = async (
  presignedURL: string,
  file: File,
  progressCallback?: (progress: number) => void
) => {
  try {
    const result = await axios.put(presignedURL, file, {
      headers: { "Content-Type": file.type },
      onUploadProgress: (e) => {
        if (typeof progressCallback !== "function" || !e.total) return;
        progressCallback(Math.round((e.loaded / e.total) * 100));
      },
    });
    return result.status === 200;
  } catch (err) {
    return false;
  }
};
